import styled from "styled-components";

const TitleStyled = styled.h1`

font-style: normal;
font-weight: bold;
font-size: 26px;
line-height: 31px;

/* identical to box height */

color: #FFFFFF;
`;

export default TitleStyled;